import type {CodeList} from 'services/codelists/types';
import type {AutocompleteOption} from '../types';

export const mapCodelistToOptions = (
  codelist: CodeList,
): AutocompleteOption[] => {
  const includeCode = [
    'BOOK_GROUP',
    'PRODUCT_GROUP',
    'WORK_BOOK_GROUP',
    'DISTRIBUTOR_STATUS',
    'PUBLISHER_STATUS',
  ].includes(codelist.id);

  return codelist.codes
    .filter(c => !c.disabled && !c.deactivated)
    .filter(
      (c, index, self) =>
        index === self.findIndex(t => t.code === c.code || t.value === c.value),
    )
    .map(c => ({
      id: c.code,
      label: includeCode ? `${c.code}: ${c.value}` : c.value,
    }));
};
